/******************************************************************
 * Archivo : client/src/queries/fetchAllSurveys.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query AllSurveyQuery {
    surveys {
      id
      published
      titulo
      descripcion

      results {
        userId
      }

      parameterization {
        active
        profileType
        genero
        nivel_educativo
        estrato
        departamento
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchAllSurveys.js